import { render, staticRenderFns } from "./bigLine.vue?vue&type=template&id=3459d7f0&scoped=true&"
import script from "./bigLine.vue?vue&type=script&lang=js&"
export * from "./bigLine.vue?vue&type=script&lang=js&"
import style0 from "./bigLine.vue?vue&type=style&index=0&id=3459d7f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3459d7f0",
  null
  
)

export default component.exports